export class Parametro {
  public Id: number;
  public Chave : string;
  public Descricao: string;
  public Valor : string;
  public Criptografado : boolean;
}
